<template>
    <el-container>
        <el-header height="64px">
            <div style="display: flex">
                <div style="height: 64px">
                    <img style="margin: 16px 0;height: 32px;cursor: pointer;" @click="$router.push({name: 'Index'})"
                         src="https://play-lh.googleusercontent.com/kJniSqlwnf6wRXOGHCsuu512sqrUz6bW_D_O0tBV13XKkD09-4NJNW5PQx1qUwJ-hcIG=w240-h480-rw">
                </div>
                <div style="padding: 0 10px;line-height: 64px;font-size: 20px;color: var(--el-text-color-regular);">
                    FunColor
                    <el-divider direction="vertical" style="font-size: 32px"></el-divider>
                </div>
            </div>
            <div>
                <el-switch style="margin: 16px" v-model="dark" @change="changeDark" class="dark-switch"
                           active-color="#44444" :active-icon="Moon" :inactive-icon="Sunny" inline-prompt></el-switch>
                <el-button size="small" type="text" @click="logout()">退出登录</el-button>
            </div>
        </el-header>
        <el-container style="background-color: var(--el-border-color-extra-light)" :style="{height: height + 'px'}">
            <aside-nav ref="nav">
                <aside-group title="素材库">
                    <aside-item icon="Files" title="全局图库" index="Index"></aside-item>
                </aside-group>
            </aside-nav>
            <el-main :style="{padding: $route.name === 'Tag'?'0':'var(--el-main-padding)'}">
                <router-view></router-view>
            </el-main>
        </el-container>
    </el-container>
</template>
<script>
import {useDark, useToggle} from '@vueuse/core';
import AsideNav from "../base/AsideNav.vue";
import AsideGroup from "../base/AsideGroup.vue";
import AsideItem from "../base/AsideItem.vue";
import axios from "ts-axios-new";
import {Sunny, Moon} from '@element-plus/icons-vue'
import {setLocalObj} from "../libs/storage";

export default {
    name: 'App',
    components: {AsideGroup, AsideItem, AsideNav},
    data() {
        return {
            dark: window.matchMedia('(prefers-color-scheme: dark)').matches, Sunny, Moon,
            width: document.documentElement.clientWidth,
            height: document.documentElement.clientHeight - 64,
            media: window.matchMedia('(prefers-color-scheme: dark)'),
            country_list: [], cdn_url: import.meta.env.VITE_CDN_URL,
            user: {
                user_id: '',
                avatar: '',
                name: '',
                email: '',
                access: [],
            },
            part_time_mode: false,
        }
    },
    methods: {
        changeDark() {
            useToggle(useDark())(this.dark);
        },
        handleScroll() {
            this.height = document.documentElement.clientHeight - 64;
            this.width = document.documentElement.clientWidth;
        },
        logout() {
          setLocalObj('authorization', null)
          location.reload();
        },
    },
    mounted() {
        window.onresize = _ => {
            this.handleScroll();
        };
        this.media.addEventListener('change', e => {
            this.dark = e.matches;
            this.changeDark();
        });
        this.changeDark();
        axios.get('https://console.plutodesk.com/api/v1/country').then(res => {
            this.country_list = res.data.data.countryList;
        });
    },
}
</script>
<style>
html, body {
    margin: 0;
    padding: 0;
}

.el-header {
    display: flex;
    padding: 0 20px;
    justify-content: space-between;
    border-bottom: solid 1px var(--el-border-color-light);
    background-color: var(--el-bg-color);
}

.dark-switch i {
    color: var(--el-text-color-primary) !important;
}
</style>